import { Phone, ShoppingBag, ArrowRight } from "lucide-react";
import { TAVERN } from "../../data/tavern";

export default function CtaRow() {
  return (
    <section
      data-testid="cta-section"
      className="py-20 md:py-28"
    >
      <div className="mx-auto max-w-6xl px-5 md:px-8">
        <div className="mb-10 text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-[color:var(--pk-primary)]">
            ΠΑΡΑΓΓΕΛΙΑ
          </p>
          <h2 className="mt-3 font-display text-3xl font-black tracking-tight text-[color:var(--pk-text)] sm:text-4xl md:text-5xl">
            Φέρτε τη γεύση μας στο τραπέζι σας
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-[color:var(--pk-text-soft)]">
            Γρήγορη παράδοση μέσω efood ή μία κλήση μακριά.
          </p>
        </div>

        <div className="grid gap-5 md:grid-cols-2 md:gap-7">
          {/* efood — RED */}
          <a
            href={TAVERN.efoodUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-efood-btn"
            className="lift group relative flex items-center justify-between gap-5 overflow-hidden rounded-2xl bg-[color:var(--pk-red)] p-7 text-white md:p-9"
          >
            <div>
              <div className="mb-3 inline-flex items-center gap-2 rounded-full bg-white/15 px-3 py-1 text-[11px] font-bold uppercase tracking-widest">
                <ShoppingBag className="h-3.5 w-3.5" strokeWidth={2.5} />
                EFOOD · ONLINE
              </div>
              <div className="font-display text-2xl font-black leading-tight sm:text-3xl md:text-4xl">
                Παραγγελία efood
              </div>
              <div className="mt-2 text-sm text-white/85 md:text-base">
                Διαλέξτε, πληρώστε, απολαύστε — χωρίς να σηκώσετε τηλέφωνο.
              </div>
            </div>
            <div
              aria-hidden="true"
              className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-white/15 transition-transform group-hover:translate-x-1 group-hover:rotate-[-8deg] md:h-16 md:w-16"
            >
              <ArrowRight className="h-6 w-6 md:h-7 md:w-7" strokeWidth={2.5} />
            </div>
            <div
              aria-hidden="true"
              className="absolute -right-10 -top-10 h-40 w-40 rounded-full bg-white/5 blur-2xl"
            />
          </a>

          {/* Phone — GREEN */}
          <a
            href={`tel:${TAVERN.phoneTel}`}
            data-testid="cta-phone-btn"
            className="lift group relative flex items-center justify-between gap-5 overflow-hidden rounded-2xl bg-[color:var(--pk-green)] p-7 text-white md:p-9"
          >
            <div>
              <div className="mb-3 inline-flex items-center gap-2 rounded-full bg-white/15 px-3 py-1 text-[11px] font-bold uppercase tracking-widest">
                <Phone className="h-3.5 w-3.5" strokeWidth={2.5} />
                ΑΜΕΣΗ ΕΠΙΚΟΙΝΩΝΙΑ
              </div>
              <div className="font-display text-2xl font-black leading-tight sm:text-3xl md:text-4xl">
                Τηλεφωνική Παραγγελία
              </div>
              <div className="mt-2 text-sm text-white/85 md:text-base">
                {TAVERN.phone} — μιλήστε μαζί μας για ειδικές παραγγελίες.
              </div>
            </div>
            <div
              aria-hidden="true"
              className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-white/15 transition-transform group-hover:translate-x-1 group-hover:rotate-[-8deg] md:h-16 md:w-16"
            >
              <ArrowRight className="h-6 w-6 md:h-7 md:w-7" strokeWidth={2.5} />
            </div>
            <div
              aria-hidden="true"
              className="absolute -right-10 -top-10 h-40 w-40 rounded-full bg-white/5 blur-2xl"
            />
          </a>
        </div>
      </div>
    </section>
  );
}
